<template>
    <div class="faq-bg-div relative flex flex-col">
        <background-image
            class="static-gradient-overlay"
            :with-gradient="false"
            :src="sectionFaq.src"
            :srcset="sectionFaq.imgSrcSet" />
        <div
            class="bg-black-700/20 px-12 z-10 flex gap-8 mobile:flex-col tablet:flex-col desktop:flex-row flex-grow phone:my-12 tablet:my-16 desktop:my-20">
            <div class="flex-1 flex items-center justify-center desktop:justify-end">
                <div class="flex flex-col items-center desktop:items-end gap-8">
                    <h2
                        class="font-bold uppercase tracking-wider desktop:text-right phone:text-2xl text-3xl"
                    >
                        {{ faqCTA.question }}
                    </h2>
                    <a
                        class="btn-gold-tight cursor-pointer"
                        target="_blank"
                        :href="faqCTA.url"
                    >
                        {{ faqCTA.buttonLabel }}
                    </a>
                </div>
            </div>
            <div class="flex-1 text-white flex flex-col justify-center gap-2">
                <details
                    v-for="item in faqItems"
                    :key="item.id"
                    class="details shadow-md border border-gold-700 rounded-md w-auto">
                    <summary
                        class="cursor-pointer list-none flex gap-4 p-3"
                        @click="toggle">
                        <span class="font-bold uppercase text-lg pointer-events-none">{{ item.title }}</span>
                        <div class="w-6 h-6 summary-icon transform transition-transform pointer-events-none">
                            <ChevronUp />
                        </div>
                    </summary>

                    <div
                        class="p-3 border-t border-gold-700"
                        v-html="item.description"></div>
                </details>
            </div>
        </div>
    </div>
</template>

<script>
import BackgroundImage from '@web/components/BackgroundImage';
import ChevronUp from '@whisper/components/icons/ChevronUp';

const getSiblings = (e) => {
  // for collecting siblings
  const siblings = [];
  // if no parent, return no sibling
  if (!e.parentNode) {
    return siblings;
  }
  // first child of the parent node
  let sibling = e.parentNode.firstChild;

  // collecting siblings
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

export default {
  name: 'SectionFaqStatic',
  components: { BackgroundImage, ChevronUp },
  props: ['sectionFaq', 'faqItems', 'faqCTA'],
  methods: {
    toggle(event) {
      getSiblings(event.target.parentElement).forEach((el) => { el.open = false; });
    },
  },
};
</script>

<style scoped lang="scss">
.faq-bg-div {
    min-height: 640px;
}

.btn-gold-tight {
    width: max-content;
}
.static-gradient-overlay::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 2;
    background-color: #151516;
    opacity: 0.7;
}

/* Accordion styles */
.details {
    background-color: rgba($color: #000000, $alpha: 0.5);
}
.details[open] .summary-icon {
    @apply rotate-180
}
summary::-webkit-details-marker {
    display: none;
}
</style>
